import { LockClosedIcon } from '@heroicons/react/24/solid'
import PropTypes from 'prop-types'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import { MODES } from '../../features/pricing/entitlements'
import { useEntitlements } from '../../features/pricing/hooks'
import { FEATURES } from '../../features/pricing/plans'
import LockBadge from '../pricing/lock-badge'

// Ohne feature, und mit feature in legacy und preview, bleibt das orange
// Schloss exakt wie bisher. Erst mit feature in enforced kommt die neutrale
// LockBadge, deren Klick den Upgrade-Dialog öffnet und nicht zum Aufrufer
// durchgereicht wird.
//
// Der Tooltip erscheint nur mit id und text. Bisher war id Pflicht, keiner der
// Aufrufer hat sie gesetzt, und der Tooltip ist nie aufgegangen. Ohne id
// rendert das Schloss deshalb wie bisher ohne Tooltip.
const LockedIcon = ({ id, text, feature, source, onClick }) => {
  const { mode } = useEntitlements()

  if (feature && mode === MODES.ENFORCED) {
    return (
      <LockBadge
        feature={feature}
        source={source}
        onClick={onClick}
        iconOnly
        className='ml-2'
      />
    )
  }

  const withTooltip = !!id && !!text

  return (
    <div>
      <div
        data-tooltip-id={withTooltip ? id : undefined}
        className='ml-2 flex h-7 w-7 items-center justify-center rounded-full border-2 border-aivyOrange'
      >
        <LockClosedIcon className='h-4 w-5 text-aivyOrange' />
      </div>
      {withTooltip && (
        <ReactTooltip
          id={id}
          content={text}
          style={{ backgroundColor: '#45586B' }}
          place='right'
          variant='info'
          className='z-20 max-w-xs rounded-full font-medium sm:max-w-sm'
        />
      )}
    </div>
  )
}

LockedIcon.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string,
  feature: PropTypes.oneOf(Object.keys(FEATURES)),
  source: PropTypes.string,
  onClick: PropTypes.func
}

LockedIcon.defaultProps = {
  id: undefined,
  text: undefined,
  feature: undefined,
  source: undefined,
  onClick: undefined
}

export default LockedIcon
